// src/store/slices/shopSlice.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useShopStore = create(
  persist(
    (set, get) => ({
      currentShop: null,
      shopInView: null, // NEW: State to hold the details of the shop being viewed
      setCurrentShop: (shop) => set({ currentShop: shop }),
      clearCurrentShop: () => set({ currentShop: null }),
      setShopInView: (shop) => set({ shopInView: shop }), // NEW: Action to set the shopInView state
    }),
    {
      name: 'shop-storage', // name of the item in the storage (must be unique)
      getStorage: () => localStorage, // the storage to use
      partialize: (state) => ({ currentShop: state.currentShop, shopInView: state.shopInView }),
    }
  )
);